import {
    OverlayTrigger,
    Table,
    Tooltip,
    Alert,
} from "react-bootstrap";
import {  CheckSquare } from "react-feather";

export default function BatchStudentsTable({ students }) {
    return (
        <Table fluid bordered hover>
            <thead className="table-light">
                <tr
                    style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                    }}
                >
                    <th>Actions</th>
                    <th>S.No</th>
                    <th>Student Name</th>
                    <th>Sponsor Company</th>
                    <th>Fin No</th>
                    <th>Trade</th>
                    <th>Application Opt</th>
                    <th>Person-in-charge</th>
                </tr>
            </thead>
            <tbody>
                {students.length === 0 ? (
                    <tr>
                        <td colSpan={8}>
                            <Alert variant="warning" className="p-2">
                                No students in this batch/class.
                            </Alert>
                        </td>
                    </tr>
                ) : (
                    students?.map((data, index) => (
                        <tr key={data?.id ?? index}>
                            <td className="text-center">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>BCA Attendance</Tooltip>}
                                >
                                    <a
                                        href={`/tms/bca-attendance/create/${data?.id}`}
                                        rel="noreferrer"
                                        className="me-1"
                                    >
                                        <span>
                                            <CheckSquare
                                                size="18"
                                                color="#6c757d"
                                            />
                                        </span>
                                    </a>
                                </OverlayTrigger>
                            </td>
                            <td>{index + 1}</td>
                            <td>{data?.enrolment?.name ?? ""}</td>
                            <td>
                                {data?.enrolment?.sponsor_company?.name ??
                                    "N/A"}
                            </td>
                            <td>{data?.enrolment?.fin ?? ""}</td>
                            <td>{data?.enrolment?.type_of_trade ?? ""}</td>
                            <td>{data?.enrolment?.application_option ?? ""}</td>
                            <td>
                                {data?.enrolment?.invoice?.sales_user?.name ??
                                    ""}
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </Table>
    );
}
